export default __webpack_public_path__ + "static/media/example_img_1_7.9f2c0f4c.png";